import * as React from 'react';
import { ScheduleDefinition } from 'app/area/company-report/types-store';
import { RecurrencePattern } from 'app/area/company-report/constants';
import { ValidationProps } from 'ui';
import { DailySchedule } from './schedule-form-daily';
import { WeeklySchedule } from './schedule-form-weekly';
import { MonthlySchedule } from './schedule-form-monthly';
import { YearlySchedule } from './schedule-form-yearly';

interface ScheduleRecurrencePatternTabsProps {
  selectedRecurrencePattern: number;
  scheduleDefinition: ScheduleDefinition;
  setScheduleDefinition: React.Dispatch<React.SetStateAction<ScheduleDefinition>>;
  scheduleWeekdayOptions: any[];
  scheduleMonthOptions: any[];
  scheduleOccurenceOptions: any[];
  locale: string;
  getValidationErrors: (key: string) => ValidationProps;
  translations: {
    every: string; every_weekday: string; days: string; recur_every: string; weeks_on: string;
    day: string; the: string; of_every: string; months: string; years: string; on: string; on_the: string; of: string;
  };
}

export const ScheduleRecurrencePatternTabs = ({
  selectedRecurrencePattern, scheduleDefinition, setScheduleDefinition, scheduleWeekdayOptions,
  scheduleMonthOptions, scheduleOccurenceOptions, locale, getValidationErrors,
  translations: { every, every_weekday, days, recur_every, weeks_on, day, the, of_every, months, years, on, on_the, of }
}: ScheduleRecurrencePatternTabsProps) => {

  const recurrencePatternTabsContent = {
    [RecurrencePattern.Daily]: <DailySchedule
      setScheduleDefinition={setScheduleDefinition}
      scheduleDefinition={scheduleDefinition}
      translations={{every, every_weekday, days}}
      locale={locale}
      getValidationErrors={getValidationErrors}
    />,
    [RecurrencePattern.Weekly]: <WeeklySchedule
      setScheduleDefinition={setScheduleDefinition}
      scheduleDefinition={scheduleDefinition}
      scheduleWeekdayOptions={scheduleWeekdayOptions}
      translations={{recur_every, weeks_on}}
      locale={locale}
      getValidationErrors={getValidationErrors}
    />,
    [RecurrencePattern.Monthly]: <MonthlySchedule
      setScheduleDefinition={setScheduleDefinition}
      scheduleDefinition={scheduleDefinition}
      scheduleWeekdayOptions={scheduleWeekdayOptions}
      occurenceOptions={scheduleOccurenceOptions}
      translations={{day, the, of_every, months}}
      locale={locale}
      getValidationErrors={getValidationErrors}
    />,
    [RecurrencePattern.Yearly]: <YearlySchedule
      setScheduleDefinition={setScheduleDefinition}
      scheduleDefinition={scheduleDefinition}
      scheduleMonthOptions={scheduleMonthOptions}
      scheduleWeekdayOptions={scheduleWeekdayOptions}
      occurenceOptions={scheduleOccurenceOptions}
      translations={{recur_every, years, months, on, on_the, of}}
      locale={locale}
      getValidationErrors={getValidationErrors}
     />
  };

  return recurrencePatternTabsContent[selectedRecurrencePattern] ?? null;
};
